import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DropdownModel} from '@shared/components/dropdown-button/model/dropdown.model';
import {PlayAudioService} from '@shared/utils/play-audio.service';
import {MatMenuTrigger} from '@angular/material/menu';

@Component({
    selector: 'app-dropdown-button',
    templateUrl: './dropdown-button.component.html',
    styleUrls: ['./dropdown-button.component.scss']
})
export class DropdownButtonComponent implements OnChanges {
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
    @Input() sideMenuOpen: boolean;
    @Input() triggerData: [{ triggerBtnIcon: string; triggerBtnClasses: string; triggerBtnIconSize: any; triggerBtnAriaLabel: string; triggerBtnIconColor: any }];
    @Input() menuItems: DropdownModel[];
    @Input() disabled: boolean | undefined;
    @Input() triggerBtnClasses: string;
    @Input() triggerBtnIcon: string;
    @Input() triggerBtnIconSize: '52';
    @Input() triggerBtnIconColor: 'gray-06' | 'gray-07';
    @Input() triggerBtnAriaLabel: string;
    @Input() tabindex: number;
    @Input('matMenuTriggerRestoreFocus') restoreFocus: boolean;
    @Output() buttonEvent = new EventEmitter<any>();
    @Output() triggerEvent = new EventEmitter<any>();

    constructor(private playService: PlayAudioService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.sideMenuOpen && this.sideMenuOpen === false) {
            this.trigger.closeMenu();
        }
    }

    onKeyDown(event): void {
        if (event.key === 'Tab') {
            event.stopPropagation();
        }
    }

    openMenu(): void {
        this.triggerEvent.emit();
    }

    onTab(event): void {
        if (event.key === 'Tab' || event.shiftKey) {
            const textForReading = event.target.getAttribute('aria-label');
            this.playService.readCommands(textForReading);
        }
    }

    handleKeyboardEvent(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.key === 'Space') {
            this.restoreFocus = true;
        }
    }
}
